import type { ReactNode } from 'react';
import { diffWords } from 'diff';

import type { RenderText } from './types';

import styles from './Diff.module.css';

const renderTextPlain: RenderText = (text) => text;

export function buildAddedLineWordDiffSpans(
  prevRemovedValue: string,
  addedValue: string,
  lineNumber: number,
  renderText: RenderText = renderTextPlain,
): ReactNode[] {
  return diffWords(prevRemovedValue, addedValue).map((change, index) => {
    if (change.added) {
      const key = `added-${lineNumber}-${index}`;
      return (
        <span className={styles.addedInner} key={key} data-line-added-inner>
          {renderText(change.value, key)}
        </span>
      );
    }
    if (change.removed) {
      return null;
    }
    const key = `unchanged-${lineNumber}-${index}`;
    return (
      <span className={styles.unchangedInner} key={key}>
        {renderText(change.value, key)}
      </span>
    );
  });
}

export function buildRemovedLineWordDiffSpans(
  removedValue: string,
  nextAddedValue: string,
  lineNumber: number,
  renderText: RenderText = renderTextPlain,
): ReactNode[] {
  return diffWords(removedValue, nextAddedValue).map((change, index) => {
    if (change.removed) {
      const key = `removed-${lineNumber}-${index}`;
      return (
        <span key={key} className={styles.removedInner} data-line-removed-inner>
          {renderText(change.value, key)}
        </span>
      );
    }
    if (change.added) {
      return null;
    }
    const key = `unchanged-${lineNumber}-${index}`;
    return (
      <span className={styles.unchangedInner} key={key}>
        {renderText(change.value, key)}
      </span>
    );
  });
}
